import { SelectInput, SelectInputProps } from "react-admin";

export const UserTypeSelect = (props: Omit<SelectInputProps, "choices">) => {
  const choices = [
    {
      id: "4",
      name: "ra.users.userType.cashier",
    },
    {
      id: "3",
      name: "ra.users.userType.user",
    },
  ];

  return <SelectInput {...props} choices={choices} />;
};

export const CashierTypeSelect = (props: Omit<SelectInputProps, "choices">) => {
  const choices = [
    {
      id: "4",
      name: "ra.users.userType.cashier",
    },
  ];

  return <SelectInput {...props} choices={choices} />;
};
